import { createFileRoute, redirect } from '@tanstack/react-router';
import { Layout } from '@/components/Layout';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: ({ context, location }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({
        to: '/login',
        search: { redirect: location.href },
      });
    }
  },
  component: Layout,
});
